export default "__VITE_ASSET__D$roic2d__"